import { useMediaQuery } from '@mui/material';

import { MediaQuery } from '@mewa/types';

import cssVars from '../styles/export-variables.module.scss';

const breakpoints = {
  breakpoints: {
    values: {
      xs: parseInt(cssVars['maxWidthVp1']),
      sm: parseInt(cssVars['maxWidthVp2']),
      mdSm: parseInt(cssVars['maxWidthMedium']),
      md: parseInt(cssVars['maxWidthVp3']),
      lg: parseInt(cssVars['maxWidthVp4']),
      xl: parseInt(cssVars['maxWidthVp4']),
    },
  },
};

export default breakpoints;

export const useCurrentBreakpoint = (): MediaQuery => {
  const isXs = useMediaQuery((theme) => theme.breakpoints.up('xs'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const isLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  if (isLg) {
    return MediaQuery.lg;
  }
  if (isMd) {
    return MediaQuery.md;
  }
  if (isSm) {
    return MediaQuery.sm;
  }
  if (isXs) {
    return MediaQuery.xs;
  }

  return MediaQuery.xs;
};
